export const isFlexibilityService = (service) =>
  service.categoryType?.toUpperCase() === 'FLEXIBILITY' ||
  service.categoryDescription?.toLowerCase() === 'flexibility' ||
  service.categoryCode?.toLowerCase() === 'flex';

export const isBaggageService = (service) =>
  service.categoryType?.toUpperCase() === 'BAGGAGE' ||
  service.categoryDescription?.toLowerCase() === 'baggage' ||
  service.categoryCode?.toLowerCase().includes('bag');
